import { Skeleton } from '@/components/ui/skeleton';
import { IoMenuSharp } from 'react-icons/io5';
import { Button } from './button';

export default function NavBarSkeleton() {
  return (
    <header className="w-full h-16 border-none px-4 bg-background flex items-center justify-between bg-sivarbet-background">
      <div className="pl-2 pr-9 flex justify-center items-center transition-all duration-1000 max-md:hidden">
        <Button variant="default" className="bg-transparent border-none p-0 hover:bg-none">
            <IoMenuSharp className="text-4xl text-slategray transition-all duration-1000" />
        </Button>
        <Skeleton className="h-9 w-[198px]" />
      </div>
      <div className="max-md:block hidden">
        <Skeleton className="h-10 w-10" />
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-9 w-16" />
        <Skeleton className="h-9 w-24" />
      </div>
    </header>
  );
}
